<template>
  <el-popover class="avatar_popover" placement="bottom" trigger="click" :visible-arrow="false" width="200">
    <div class="avatar_popover_content">
      <div class="content_top flex flex_direction">
        <h1 class="text_size_16 margin-bottom-10">{{ formData.username }}</h1>
        <h1 class="text_size_14 text_color_active">{{ roleName }}</h1>
      </div>
      <div class="content_bottom flex flex_direction">
        <div @click="$router.push(`/outer/account`)" class="handle_item flex align_center">
          <i class="iconfont icongerenshezhi margin-right-20"></i>
          <h1 class="text_size_14">账号管理</h1>
        </div>
        <div class="handle_item flex align_center" @click="signOut">
          <i class="iconfont icontuichudenglu margin-right-20"></i>
          <h1 class="text_size_14">退出登录</h1>
        </div>
      </div>
    </div>
    <div slot="reference" class="avatar_popover_reference flex align_center cursor_pointer">
      <el-image class="image" :src="formData.avatar_url" />
    </div>
  </el-popover>
</template>
<script>
import * as api from '~/api'
import cookie from '~/utils/cookie'
export default {
  data () {
    return {
      // 表单数据
      formData: {
        // id
        id: '',
        // 头像
        avatar_url: '',
        // 姓名
        username: '',
        // 权限
        role: '',
        // 电话
        mobile: '',
        // 性别
        gender: '',
        // 组织单位
        company: '',
        // 邮箱
        email: ''
      }
    }
  },
  computed: {
    // 角色对应的名称
    roleName () {
      let roleName = ''
      switch (this.formData.role) {
        case this._global.PROJECT_ADMIN:
          roleName = '总负责人'
          break
        case this._global.PROJECT_CONTACT:
          roleName = '项目联系人'
          break
        case this._global.TOPIC_ADMIN:
          roleName = '课题负责人'
          break
        case this._global.TOPIC_CONTACT:
          roleName = '课题联系人'
          break
        case this._global.UNIT_ADMIN:
          roleName = '单位负责人'
          break
        case this._global.UNIT_CONTACT:
          roleName = '单位联系人'
          break
        case this._global.MEMBER:
          roleName = '单位成员'
          break
      }
      return roleName
    }
  },
  created () {
    // 获取用户信息
    this.getUserInfo()
  },
  methods: {
    // 获取用户信息
    getUserInfo () {
      api.getUserInfo().then(res => {
        if (res.data.code === 0) {
          console.log('获取账号信息成功', res.data.data)
          this.formData = res.data.data
          this.$store.commit('SET_USER_INFO', res.data.data)
        }
      })
    },
    // 退出登录
    signOut () {
      this.$router.push('/login')
      // 删除token
      cookie.remove('token')
      // 重置vuex中用户的信息
      this.$store.commit('SET_USER_INFO', {
        // 用户id
        id: '',
        // 头像
        avatar: '',
        // 姓名
        name: '',
        // 权限
        role: '',
        // 电话
        mobile: '',
        // 性别
        gender: '',
        // 组织单位
        unit: '',
        // 邮箱
        email: ''
      })
      // 重置基本信息
      this.$store.commit('SET_BASE_INFO', {
        // 角色
        role: '',
        // 文档类型下拉
        docs: [],
        // 课题组
        subjects: [],
        // 当前课题
        current_subject: {
          id: '',
          name: ''
        },
        // 当前单位
        current_company: {
          id: '',
          name: ''
        },
        // 成果类型
        achievements: []
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .avatar_popover_content {
    .content_top {
      width: 100%;
      height: 80px;
      padding: 20px 0 10px 20px;
      border-bottom: 0.5px solid $border-color-base;
      & > h1 {
        height: 20px;
      }
    }
    .content_bottom {
      width: 100%;
      height: 100px;
      border-top: 0.5px solid $border-color-base;
      padding: 0 0 20px 0;
      .handle_item {
        padding-left: 20px;
        height: 40px;
        transition: all 0.3s ease;
        cursor: pointer;
        &:hover {
          background-color: $--color-primary-light-9;
        }
      }
    }
  }
  .avatar_popover {
    .avatar_popover_reference {
      height: 50px;
      padding: 0 39px;
      &:hover {
        background-color: $--color-primary-light-9;
      }
      .image {
        width:32px;
        height:32px;
        border-radius:50%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/container/header/header-avatar.vue